import React, { forwardRef, ReactNode, useEffect, useState } from "react";
import { ImageBackground, ImageSourcePropType, View, StyleSheet, StyleProp, ImageStyle } from "react-native";
import getGlobalStyles from '../globalStyles';
import { useActiveArticle } from "../features/news-feed/hooks/useActiveArticle";
import { useRoute } from "@react-navigation/native";
import { ROUTES } from "../shared/constants/routes";
import { FOOTER_HEIGHT, FULL_HEIGHT, FULL_WIDTH } from "../shared/constants/dimension";
import CustomLinearGradient, { GRADIENT_TYPE } from "./CustomLinearGradient";
import { usePlatform } from "../providers/PlatformProvider";
import { useThemeSettings } from "../ThemeProvider";
import { getImageUri } from "../shared/helpers/utils";

interface BackgroundProps {
  children: ReactNode;
  bgImage?: ImageSourcePropType;
  imageStyle?: StyleProp<ImageStyle>;
}
const AppBackground = forwardRef<View, BackgroundProps>((props, ref) => {
  const gStyles = getGlobalStyles();
  const { activeArticle } = useActiveArticle();
  const { theme } = useThemeSettings();
  const route = useRoute();
  const { showWebVersion } = usePlatform();

  // Determine background image: use active article image or fallback to provided bgImage
  const [backgroundImage, setBackgroundImage] = useState<any>(props?.bgImage);
  useEffect(() => {
    if (!props?.bgImage) {
      if (!showWebVersion)
        switch (route.name) {
          case ROUTES.LISTEN:
          case ROUTES.IMMERSRSIVE_NEWS_ARTICLE:
          case ROUTES.RADIO_PLAYER:
            if (activeArticle?.image) {
              setBackgroundImage(getImageUri(activeArticle.image!));
            }
            break;
        }
    } else {
      setBackgroundImage(props?.bgImage);
    }
  }, [activeArticle, route.name, props?.bgImage]);

  const getChildren = () => {
    return backgroundImage ?
      <ImageBackground
        imageStyle={props.imageStyle}
        blurRadius={5}
        source={backgroundImage}
        resizeMode="cover"
        style={styles.contain}
      >
        <View style={{ height: FULL_HEIGHT, backgroundColor: `${theme?.colors?.appBackground2}95` }}>
          {props?.children}
        </View>
      </ImageBackground>
      :
      <CustomLinearGradient
        gradientType={showWebVersion? GRADIENT_TYPE.BASE_WEB : GRADIENT_TYPE.BASE}>
        {props?.children}
      </CustomLinearGradient>;
  }
  return (
    <View style={[gStyles.centerContainer]} ref={ref} collapsable={false} >
      {getChildren()}
    </View>
  );
});

export default AppBackground;

const styles = StyleSheet.create({
  contain: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: FULL_WIDTH,
  },
});